/* global System */
// register component(s) with react habitat
import codeSplit from 'scripts/higher-order-components/codeSplit'
import l10n from './l10n'

export default {
  ExampleComponent: codeSplit({
    l10n,
    loadComponent: () =>
      System.import(
        /* webpackChunkName: "ExampleComponent" */
        './index'
      ),
  }),
}
